import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_7: FaireProductEntity = {
  token: "atc_toast_7",
  type: "product",
  name: "Organic Cotton Throw Blanket",
  brandName: "Coyuchi",
  imageUrl: "",
  priceDollars: 42.0,
  msrpDollars: 85.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
